export default "__VITE_PUBLIC_ASSET__61ad670d__"